/* Register service worker for PWA offline support.
 * Only runs in production builds (CRA dev server doesn't play nicely with SWs). */
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  // Skip on the preview dev environment so hot-reload works as expected
  if (process.env.NODE_ENV !== 'production') return;
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        // Listen for updates and auto-activate so users get latest after reload
        reg.addEventListener('updatefound', () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener('statechange', () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              sw.postMessage('SKIP_WAITING');
            }
          });
        });
      })
      .catch((err) => {
        // Silent — SW is enhancement, not requirement
        console.warn('SW registration failed', err);
      });
  });
}
